export default [
  {
    name: 'home',
    path: '/',
  },
  {
    name: 'search.index',
    path: '/search',
  },
  {
    name: 'directory.index',
    path: '/directory/:type',
  },
  {
    name: 'directory.company.index',
    path: '/directory/company/:country/:key',
  },
  {
    name: 'directory.product.index',
    path: '/directory/product/:key',
  },
  {
    name: 'directory.classification.index',
    path: '/directory/classification/:key',
  },
  {
    name: 'directory.brand.index',
    path: '/directory/brand/:key',
  },
  {
    name: 'classification.index',
    path: '/classification/:slug',
  },
  {
    name: 'brand.index',
    path: '/brand/:slug',
  },
  {
    name: 'form.request_for_quote.index',
    path: '/request-for-quotation',
  },
  {
    name: 'keepital.pages.article.index',
    path: '/corporate/:articleSlug',
  },
  {
    name: 'keepital.checkout',
    path: '/:type/checkout',
  },
  {
    name: 'subscription.enrolment',
    path: '/enrolment/:companyID',
  },
  {
    name: 'keepital.thankyou',
    path: '/checkout/thankyou',
  },
];
